// extracted by mini-css-extract-plugin
export default {"statusDot":"status_dot_statusDot__3jGbL","greenDot":"status_dot_greenDot__x5QF9","redDot":"status_dot_redDot__rYdUg"};